import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, CardHeader } from '@mui/material';
import T from 'prop-types';
import { NotifyIcon, NotifyTypo } from 'web-components';
import { IrisBatchTargetPropTypes } from '../../../../../../helpers/propTypes';
import { getValueToNullableCell } from '../../../../../../helpers/stringHandler';
import IrisBatchRecordsEditTarget from '../../IrisBatchRecordsEditModal/IrisBatchRecordsEditTarget';

const labelAmend = 'machines.machine_details.batch_iris.target';

const IrisBatchTarget = ({ target, machineId }) => {
  const { t } = useTranslation();
  const [editModal, setEditModal] = useState(false);
  const handleClose = () => setEditModal(false);

  const defaultTarget = target?.default_target;

  return (
    <>
      <CardHeader
        sx={{ p: 0, alignItems: 'flex-start', mb: 0 }}
        action={
          <Button
            variant="text"
            sx={{ p: 1.5, gap: 1, display: 'flex', height: '50px', width: '96px' }}
            onClick={() => setEditModal(true)}
          >
            <NotifyIcon iconName="edit" fontSize="medium" />
            {t(`machines.machine_details.edit`)}
          </Button>
        }
        title={
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ mt: '15px', fontSize: '16px' }}>{t(`${labelAmend}.title`)}</Box>
          </Box>
        }
        titleTypographyProps={{
          fontWeight: '500',
          variant: 'Body1'
        }}
      />
      <NotifyTypo.Subtitle1 fontWeight="400">{t(`${labelAmend}.subtitle`)}</NotifyTypo.Subtitle1>
      <Box display="grid" gridTemplateColumns="repeat(5, 1fr)" gap={2} sx={{ mt: 3, mb: 2 }}>
        <Box gridColumn="span 1">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmend}.target_type_variable`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>{getValueToNullableCell(defaultTarget?.target_type_variable)}</NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 4">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmend}.target_value_variable`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>{getValueToNullableCell(defaultTarget?.target_value_variable)}</NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 1">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmend}.target_comment_1`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>{getValueToNullableCell(defaultTarget?.target_comment_1)}</NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 1">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmend}.target_comment_2`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>{getValueToNullableCell(defaultTarget?.target_comment_2)}</NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 1">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmend}.target_comment_3`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>{getValueToNullableCell(defaultTarget?.target_comment_3)}</NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 1">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmend}.target_comment_4`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>{getValueToNullableCell(defaultTarget?.target_comment_4)}</NotifyTypo.Body1>
        </Box>
      </Box>

      <IrisBatchRecordsEditTarget
        open={editModal}
        handleClose={handleClose}
        data={defaultTarget}
        machineId={machineId}
      />
    </>
  );
};

IrisBatchTarget.propTypes = {
  target: IrisBatchTargetPropTypes,
  machineId: T.string.isRequired
};

IrisBatchTarget.defaultProps = {
  target: null
};

export default IrisBatchTarget;
